// 渲染文件
import React, {memo, useState} from 'react'
import DownloadImg from "../../img/download.png";
import styled from 'styled-components'
import {fileFormat} from '../common/file/formatIcon'
import {calFileSize} from "../../utils/utils";

const FileMsg = styled.div`
  width: 240px;
  height: 80px;
  margin-top: 8px;
  border: 1px solid #D9D9D9;
  padding: 8px;
  display: flex;
`
const Description = styled.div`
  width: 168px;
  height: 44px;
  font-size: 12px;
  line-height: 22px;
  color: #595959;
`
const FileName = styled.div`
  height: 44px;
  color: #595959;
  overflow: hidden;
`
const FileSize = styled.div`
  font-size: 12px;
  color: #BFBFBF;
  margin-top: 2px;
`
const Icons = styled.div`
  margin-left: 10px;
  text-align: right;
  width: 44px;
  img {
    width: 40px;
    height: 40px;
  }
`

const DownloadIcon = styled.img`
  cursor: pointer;
  margin-top: 4px;
`
const RenderFileMsg = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  const [showDownload, setShowDownload] = useState(false)
  const splitName = () => {
    if (message.fileName && message.fileName.length > 35) {
      let filename = message.fileName.slice(0, 35)
      return `${filename}...`
    } else {
      return `${message.fileName}`
    }
  }
  return (
    <FileMsg
      onMouseOver={() => setShowDownload(true)}
      onMouseLeave={() => setShowDownload(false)}
    >
      <Description>
        <FileName>
          {splitName()}
        </FileName>
        <FileSize>
          {calFileSize(message.sdkSize)}
        </FileSize>
      </Description>
      <Icons>
        <img src={fileFormat(message.fileExt)} alt="文件图标"/>
        {
          showDownload && <DownloadIcon style={{
            width: '20px',
            height: '20px'
          }} classname='downloadImg' src={DownloadImg} onClick={() => {
            window.location = message.url
          }}/>
        }
      </Icons>
    </FileMsg>
  )
})

export default RenderFileMsg
